import { Checkbox } from "antd";
import PropTypes from "prop-types";

export const CustomCheckbox = ({
  id,
  className,
  value,
  onChange,
  options,
  horizontal = false,
  maxWidth
}) => (
  <Checkbox.Group
    id={id}
    className={className || "custom-checkbox"}
    options={options}
    defaultValue={value}
    value={value}
    onChange={onChange}
    style={{ flexDirection: horizontal ? "row" : "column", maxWidth }}
  />
);

CustomCheckbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  options: PropTypes.array,
  horizontal: PropTypes.bool,
  maxWidth: PropTypes.string
};